import moment from 'moment';
import 'moment/locale/id';
import { getFileName, getMimeTypeFile } from '@crema/utility/Utils';
import {
    ADD_ATTACHMENT_PROGRAM_KERJA,
    DELETE_ATTACHMENT_PROGRAM_KERJA,
    GET_LIST_PROGRAM_KERJA,
    SET_ATTACHMENT_PROGRAM_KERJA,
    GET_DASHBOARD_PROGRAM_KERJA,
    GET_OPTION_PROGRAM_KERJA,
    GET_OPTION_STATUS_PROGRAM_KERJA,
    GET_OPTION_INTERVENSI_PROGRAM_KERJA,
    RESET_DATA_PROGRAM_KERJA,
    GET_ESELON_LIST,
    GET_CREATE_KOMENTAR_PROGRAM_KERJA,
    RESET_KOMENTAR_PROGRAM_KERJA,
} from 'shared/constants/ActionTypes';

moment.locale('id')

const INIT_STATE = {
    options: {
        tipe: [],
        status: [],
        intervensi: []
    },
    counter: {
        "total_program": 0,
        "program_selesai": 0,
        "program_aktif": 0,
        "program_tertunda": 0,
        "rata_rata_realisasi": 0.0,
    },
    chart: {
        option: [],
        lineChart: [],
    },
    data: {
        results: [],
    },
    eselon: [],
    komentar: [],
    profile: null,
    attachments: [],
};

const programKerjaReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ESELON_LIST: {
            const results = action.payload?.result || action.payload?.results
            const list = results.filter((item) => item.nama !== null)
            const tmpData = list.map((item) => ({ id: item.key, label: item.original_name, ...item }))
            return {
                ...state,
                eselon: tmpData,
            }
        }
        case GET_OPTION_PROGRAM_KERJA: {
            const results = action.payload?.result || action.payload?.results
            const list = results.filter((item) => item.nama !== null)
            const tmpChoice = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                options: {
                    ...state.options,
                    tipe: tmpChoice,
                }
            }
        }
        case GET_OPTION_STATUS_PROGRAM_KERJA: {
            const results = action.payload?.result || action.payload?.results
            const list = results.filter((item) => item.nama !== null)
            const tmpChoice = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                options: {
                    ...state.options,
                    status: tmpChoice,
                }
            }
        }
        case GET_OPTION_INTERVENSI_PROGRAM_KERJA: {
            const results = action.payload?.result || action.payload?.results
            const list = results.filter((item) => item.nama !== null)
            const tmpChoice = list.map((item) => ({ id: item.key, label: item.name }))
            return {
                ...state,
                options: {
                    ...state.options,
                    intervensi: tmpChoice,
                }
            }
        }
        case GET_LIST_PROGRAM_KERJA: {
            return {
                ...state,
                data: action.payload,
            }
        }
        case ADD_ATTACHMENT_PROGRAM_KERJA: {
            let attObj = {
                id: action.payload.id,
                file: action.payload.file,
                size: action.payload.file_size,
                name: getFileName(action.payload.file),
                type: getMimeTypeFile(action.payload.file, action.payload.mime_type),
            }
            return {
                ...state,
                attachments: [...state.attachments, attObj],
            }
        }
        case SET_ATTACHMENT_PROGRAM_KERJA: {
            return {
                ...state,
                attachments: action.payload
            }
        }
        case DELETE_ATTACHMENT_PROGRAM_KERJA: {
            return {
                ...state,
                attachments: action.payload
            }
        }
        case GET_DASHBOARD_PROGRAM_KERJA: {
            let data = action.payload.result || action.payload.results
            return {
                ...state,
                counter: {
                    total_program: data.total_program,
                    program_selesai: data.program_selesai,
                    program_aktif: data.program_aktif,
                    program_tertunda: data.program_tertunda,
                    rata_rata_realisasi: data.rata_rata_realisasi,
                },
                chart: {
                    lineChart: data?.chart_data,
                    option: transformDashboardProgramKerja(data?.chart_data),
                },
                profile: data.profile_data
            }
        }
        case RESET_DATA_PROGRAM_KERJA: {
            return {
                ...state,
                counter: {
                    "total_program": 0,
                    "program_selesai": 0,
                    "program_aktif": 0,
                    "program_tertunda": 0,
                    "rata_rata_realisasi": 0.0,
                },
                chart: {
                    option: [],
                    lineChart: [],
                },
                data: {
                    results: [],
                },
                profile: null,
                komentar: [],
                attachments: [],
            }
        }
        case GET_CREATE_KOMENTAR_PROGRAM_KERJA: {
            const payload = action.payload?.result || action.payload?.results
            let tmpData = payload.length > 0 ? payload.map((item) => ({ creator: item?.full_name, created_at: moment(item?.timestamp).format('DD MMMM YYYY | hh:mm'), message: item?.text, ...item })) : []

            return {
                ...state,
                komentar: tmpData
            }
        }
        case RESET_KOMENTAR_PROGRAM_KERJA: {
            return {
                ...state,
                komentar: []
            }
        }
        default:
            return state;
    }
};

const generatePastelColor = (seed) => {     // from chatgpt
    const hash = Array.from(seed).reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
    const h = Math.abs(hash) % 360;
    const s = 70 + (Math.abs(hash) % 10);
    const l = 75;
    return `hsl(${h}, ${s}%, ${l}%)`;
}

const transformDashboardProgramKerja = (data) => {
    let tmpOption = []
    let keySet = new Set()  // for collect all keys in data

    // loop all data and store it first in keySet data
    for (let i = 0; i < data.length; i++) {
        const item = data[i]
        for (let key in item) {
            if (key !== 'bulan') {
                keySet.add(key)
            }
        }
    }

    // loop all key in keySet and push it into tmpOption for Option data chart
    for (let key of keySet) {
        tmpOption.push({
            name: key,
            color: generatePastelColor(key)
        })
    }

    return tmpOption
}

export default programKerjaReducer;
